// assets/teeinblue-dawn-drawer-fix.js

(function () {
  // Refresh Dawn's cart drawer + cart bubble by re-rendering the same sections Dawn uses.
  async function refreshDawnCartUI({ openDrawer = true, lastAddedVariantId = null } = {}) {
    const drawer = document.querySelector('cart-drawer');
    const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

    // If the shop is set to "page" cart type, there may be no drawer element.
    if (!drawer || typeof drawer.renderContents !== 'function') {
      // Still try to update the cart bubble if it exists
      try {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const res = await fetch(`${cartUrl}?sections=cart-icon-bubble`, { credentials: 'same-origin' });
          const sections = await res.json();
          bubble.innerHTML = sections['cart-icon-bubble'];
        }
      } catch (e) {
        console.warn('[TeeInBlue → Dawn] Could not refresh cart bubble:', e);
      }
      return;
    }

    // Use Dawn's own section list when available (most reliable across versions).
    const sectionIds =
      (typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((s) => s.id)
        : ['cart-drawer', 'cart-icon-bubble']
      ).filter(Boolean);

    try {
      const res = await fetch(`${cartUrl}?sections=${encodeURIComponent(sectionIds.join(','))}`, {
        credentials: 'same-origin',
      });

      const sections = await res.json();

      // Dawn's renderContents expects an object like the /cart/add response:
      // { id: ..., sections: { 'cart-drawer': '<html>', 'cart-icon-bubble': '<html>' } }
      drawer.renderContents({
        id: lastAddedVariantId,
        sections,
      });

      if (openDrawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    } catch (e) {
      console.warn('[TeeInBlue → Dawn] Failed to refresh cart drawer sections:', e);
    }
  }

  // TeeInBlue can call Shopify.onItemAdded(lineItem). We wrap it safely.
  window.Shopify = window.Shopify || {};
  const previousOnItemAdded = window.Shopify.onItemAdded;

  window.Shopify.onItemAdded = function (lineItem) {
    // Preserve any existing handler
    if (typeof previousOnItemAdded === 'function') {
      try { previousOnItemAdded(lineItem); } catch (e) {}
    }

    // Try to infer variant id if provided
    const variantId =
      (lineItem && (lineItem.variant_id || lineItem.variantId || lineItem.id)) || null;

    refreshDawnCartUI({ openDrawer: true, lastAddedVariantId: variantId });
  };

  // Optional: also refresh when the page becomes visible again (helps if an app adds asynchronously)
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      refreshDawnCartUI({ openDrawer: false });
    }
  });
})();
